/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import { Link } from '@/i18n/routing';
import React from 'react';

interface MobileNavLinkProps {
  href: string | { pathname: string };
  name: string;
  closemenu?: () => void;
}

export default function MobileNavLink({ href, name, closemenu }: MobileNavLinkProps) {
  return (
    <Link
      href={href as any}
      className="text-lg font-bold text-text-main/80 hover:text-primary transition-colors"
      onClick={closemenu}
    >
      {name}
    </Link>
  );
} 